// ServiceSpecificationに基づいてDeliveryMethodのFeatureFlagsを作成します。
import { ServiceSpecification } from '@service_specification/specification_commonjs/stailer_service_specification/v1/service_specification_pb'

// パートナー設定の配送方法に関するFeatureFlagsを作成します。
export function createPartnerConfigFeatureFlagsDeliveryMethodPart(spec: ServiceSpecification) {
  const getDeliveryMethod = () => spec.fulfillment?.deliveryMethod
  const getHomeDeliveryServices = () => {
    const homeDelivery = getDeliveryMethod()?.homeDelivery
    if (homeDelivery?.case === 'enableHomeDelivery') {
      return homeDelivery.value.homeDeliveryServices || []
    }
    return []
  }

  return {
    get isDssAllowed(): boolean {
      const services = getHomeDeliveryServices()
      return services.some((service) => service.homeDeliveryService.case === 'dss')
    },
    get useInStoreArrangedDelivery(): boolean {
      const deliveryMethod = getDeliveryMethod()
      return (
        deliveryMethod?.lifeInStoreArrangedDelivery.case === 'enableLifeInStoreArrangedDelivery'
      )
    },
    get enableOutgoingCallHistory(): boolean {
      // home_delivery_servicesの中にstailer_tmsがあり、かつenable_outgoing_callがtrueの場合にtrueを返す
      const services = getHomeDeliveryServices()
      return services.some(
        (service) =>
          service.homeDeliveryService.case === 'stailerTms' &&
          service.homeDeliveryService.value.enableOutgoingCall === true,
      )
    },
    get enableChangeDeliveryTime(): boolean {
      return spec.fulfillment?.pickPack?.case === 'stailerPickPack'
    },
  }
}
